import {ChangeDetectionStrategy,Component,inject} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {filter} from 'rxjs';
import {NavigationEnd,Router,RouterOutlet} from '@angular/router';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer,Meta,Title} from '@angular/platform-browser';
import {HeaderComponent} from './misc/components/header/header';
import {DrawerComponent} from './misc/components/drawer/drawer';
import {FooterComponent} from './misc/components/footer/footer';
import {CookieConsentComponent} from './misc/components/cookie-consent/cookie-consent';
import {AppService} from './app.service';
import {SwUpdateService} from './common/sw-update.service';

@Component({
	selector:'app-root',
	imports:[RouterOutlet,MatSidenavModule,HeaderComponent,DrawerComponent,FooterComponent,CookieConsentComponent],
	templateUrl:'./app.html',
	styleUrl:'./app.scss',
	changeDetection:ChangeDetectionStrategy.OnPush
})
export class App{
	readonly title=$localize`:site title:L&O Medical`;
	readonly appService=inject(AppService);
	private readonly swUpdateService=inject(SwUpdateService);
	
	private readonly matIconRegistry=inject(MatIconRegistry);
	private readonly domSanitizer=inject(DomSanitizer);
	private readonly meta=inject(Meta);
	private readonly titleService=inject(Title);
	private readonly router=inject(Router);

	constructor(){
		this.matIconRegistry.addSvgIcon(
			'app-instagram',
			this.domSanitizer.bypassSecurityTrustResourceUrl('images/icon-instagram.svg')
		);
		this.matIconRegistry.addSvgIcon(
			'app-whatsapp',
			this.domSanitizer.bypassSecurityTrustResourceUrl('images/icon-whatsapp.svg')
		);
		
		this.swUpdateService.initialize();

		this.router.events.pipe(
			filter((event):event is NavigationEnd=>event instanceof NavigationEnd),
			takeUntilDestroyed()
		).subscribe((event)=>this.appService.updateSeoUrls(event.urlAfterRedirects));
		
		const description=$localize`:app description:L&O Medical`;
		this.titleService.setTitle(this.title);
		this.meta.updateTag({content:this.title},'property="og:title"');
		this.meta.updateTag({content:description},'name="description"');
		this.meta.updateTag({content:description},'property="og:description"');
		this.meta.updateTag({content:$localize`:app keywords:lyo, l&o, medical, medicina, biorreguladora, sueroterapia, autosanguis, bogotá, soacha, ibagué`},'name="keywords"');
		this.meta.updateTag({content:this.appService.ogImageUrl},'property="og:image"');
	}
}
